import { PropsWithChildren } from "react"
import * as Icons from "@nova/component-icons"
import { NovaSpinner } from "@nova/component-nova-spinner"
import classNames from "classnames"

type CommentImageThumbnailProps = PropsWithChildren<{
    url: string
    status?: "uploading" | "done" | "error"
    onClick?: () => void
    className?: string
}>

export const CommentImageThumbnail = ({
    url,
    status,
    onClick,
    className,
    children,
}: CommentImageThumbnailProps) => (
    <button
        type="button"
        onClick={onClick}
        className={classNames(
            "group/image relative h-20 w-20 shrink-0 overflow-hidden rounded-md bg-gray-700",
            onClick && "cursor-pointer",
            className
        )}
    >
        <img
            src={url}
            alt=""
            className={classNames(
                "absolute inset-0 h-full w-full object-cover",
                status === "uploading" && "opacity-50"
            )}
        />
        {status === "uploading" && (
            <div className="absolute inset-0 flex items-center justify-center">
                <NovaSpinner width={24} height={24} />
            </div>
        )}
        {status === "error" && (
            <div className="absolute inset-0 flex items-center justify-center bg-red-500/30">
                <Icons.SmallIcon Icon={Icons.Warning} className="size-5 text-white" />
            </div>
        )}
        {children}
    </button>
)
